<template>
  <v-layout wrap class="container px-2 py-0">
    <auto-navigation />
    <router-view />
  </v-layout>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import AutoNavigation from '@/components/auto/AutoNavigation.vue';

export default {
  name: 'AutoPage',
  components: {
    AutoNavigation,
  },
  watch: {
    '$route.params.autoId': {
      immediate: true,
      handler(id) {
        this.fetchAutoTitle({ id });
      },
    },
  },
  destroyed() {
    this.setAutoTitle('');
  },
  methods: {
    ...mapActions({
      fetchAutoTitle: 'auto/fetchAutoTitle',
    }),
    ...mapMutations({
      setAutoTitle: 'auto/setAutoTitle',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
